import Button from './Button';

interface LoadMoreButtonProps {
  onLoadMore: () => void;
  loading: boolean;
  hasMore: boolean;
  totalCount: number;
  currentCount: number;
  className?: string;
}

export default function LoadMoreButton({
  onLoadMore,
  loading,
  hasMore,
  totalCount,
  currentCount,
  className = '',
}: LoadMoreButtonProps) {
  if (!hasMore) {
    return (
      <div className={`text-center py-8 ${className}`}>
        <p className="text-gray-600">
          Viser alle {totalCount} produkter
        </p>
      </div>
    );
  }

  return (
    <div className={`text-center py-8 ${className}`}>
      <Button
        onClick={onLoadMore}
        disabled={loading}
        className="px-8 py-3 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? (
          <div className="flex items-center space-x-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            <span>Indlæser...</span>
          </div>
        ) : (
          <div className="flex items-center space-x-2">
            <span>Indlæs flere produkter</span>
            <i className="ri-arrow-down-line"></i>
          </div>
        )}
      </Button>
      <p className="text-sm text-gray-500 mt-2">
        Viser {currentCount} af {totalCount} produkter
      </p>
    </div>
  );
}
